import { Directive, Output, EventEmitter, HostListener, Input, ElementRef, AfterViewInit } from "@angular/core";

@Directive({
    selector: "[scrollTracker]",
})
export class ScrollTrackerDirective {
    @Output() scrolledToBottom = new EventEmitter<void>();

    constructor(private el: ElementRef) {}

    @HostListener("scroll", ["$event"])
    onScroll(event: Event): void {
        const element = this.el.nativeElement;
        const atBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 10;

        if (atBottom) {
            this.scrolledToBottom.emit();
        }
    }
}
